export default __webpack_public_path__ + "images/G9.97eaefd.png";